module.exports = __webpack_public_path__ + "fa6577fecc0a7838f15a254577639984.png";